import { relations } from 'drizzle-orm'
import { boolean, index, pgTable, text, timestamp, unique, uuid } from 'drizzle-orm/pg-core'
import { users } from '../schema'
import { tenants } from './tenants'
import { trainings } from './training'

// Training Surveys
export const trainingSurveys = pgTable(
  'training_surveys',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    trainingId: uuid('training_id')
      .notNull()
      .references(() => trainings.id, { onDelete: 'cascade' }),
    formsUrl: text('forms_url').notNull(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').notNull().defaultNow(),
    updatedAt: timestamp('updated_at').notNull().defaultNow(),
  },
  (table) => ({
    trainingIdUnique: unique().on(table.trainingId),
    trainingIdIdx: index('training_surveys_training_id_idx').on(table.trainingId),
    tenantIdIdx: index('training_surveys_tenant_id_idx').on(table.tenantId),
  }),
)

// Survey Responses
export const surveyResponses = pgTable(
  'survey_responses',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    surveyId: uuid('survey_id')
      .notNull()
      .references(() => trainingSurveys.id, { onDelete: 'cascade' }),
    userId: uuid('user_id')
      .notNull()
      .references(() => users.id),
    completed: boolean('completed').notNull().default(false),
    completedAt: timestamp('completed_at'),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').notNull().defaultNow(),
  },
  (table) => ({
    surveyUserUnique: unique().on(table.surveyId, table.userId),
    surveyIdIdx: index('survey_responses_survey_id_idx').on(table.surveyId),
    tenantIdIdx: index('survey_responses_tenant_id_idx').on(table.tenantId),
  }),
)

// Relations
export const trainingSurveysRelations = relations(trainingSurveys, ({ one, many }) => ({
  training: one(trainings, {
    fields: [trainingSurveys.trainingId],
    references: [trainings.id],
  }),
  surveyResponses: many(surveyResponses),
}))

export const surveyResponsesRelations = relations(surveyResponses, ({ one }) => ({
  survey: one(trainingSurveys, {
    fields: [surveyResponses.surveyId],
    references: [trainingSurveys.id],
  }),
  user: one(users, {
    fields: [surveyResponses.userId],
    references: [users.id],
  }),
}))

// Type exports
export type TrainingSurvey = typeof trainingSurveys.$inferSelect
export type NewTrainingSurvey = typeof trainingSurveys.$inferInsert

export type SurveyResponse = typeof surveyResponses.$inferSelect
export type NewSurveyResponse = typeof surveyResponses.$inferInsert
